import React, {Component} from 'react'
import propTypes from 'prop-types'
import Draggable from 'components/draggable'

const getStyles = (props) => {
  const {handleSize} = props
  return {
    container: {
      position: 'relative',
      display: 'inline-block',
      width: '100%',
      height: '100%',
    },
    handle: {
      position: 'absolute',
      zIndex: 10,
    },
    hHandle: {
      height: '100%',
      width: handleSize,
      cursor: 'e-resize',
    },
    vHandle: {
      width: '100%',
      height: handleSize,
      cursor: 'n-resize',
    },
    rightHandle: {
      right: -(handleSize / 2),
    },
    leftHandle: {
      left: -(handleSize / 2),
    },
    topHandle: {
      top: -(handleSize / 2),
    },
    bottomHandle: {
      bottom: -(handleSize / 2),
    },
  }
}

class Resizable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      root: null,
    }
    this.containerRef = React.createRef()
  }

  recordPos = () => {
    const root = this.containerRef.current.getBoundingClientRect()
    this.setState({
      root: {
        top: root.top,
        left: root.left,
        width: root.width,
        height: root.height,
      },
    })
  }

  leftChange = (pos) => {
    const newPos = {...this.state.root}
    const change = pos.left - pos.root.left
    newPos.left += change
    newPos.width -= change
    this.props.onSize(newPos, this.state.root)
  }

  rightChange = (pos) => {
    const newPos = {...this.state.root}
    const change = pos.left - pos.root.left
    newPos.width += change
    this.props.onSize(newPos, this.state.root)
  }

  topChange = (pos) => {
    const newPos = {...this.state.root}
    const change = pos.top - pos.root.top
    newPos.top += change
    newPos.height -= change
    this.props.onSize(newPos, this.state.root)
  }

  bottomChange = (pos) => {
    const newPos = {...this.state.root}
    const change = pos.top - pos.root.top
    newPos.height += change
    this.props.onSize(newPos, this.state.root)
  }

  getHandlePreview = (orientation) => {
    const style = {
      display: 'inline-block',
      backgroundColor: this.context.muiTheme.palette.primary1Color,
      opacity: 0.5,
      height: 5,
      width: 5,
    }

    if (orientation === 'x') {
      style.height = this.props.height
    } else {
      style.width = this.props.height
    }

    return <span style={style}/>
  }

  render() {
    const {handles} = this.props
    let {leftRightPreview, upDownPreview} = this.props
    const styles = getStyles(this.props)

    if (leftRightPreview == null) leftRightPreview = this.getHandlePreview('x')
    if (upDownPreview == null) upDownPreview = this.getHandlePreview('y')

    const handleElms = []
    if (handles.up) handleElms.push(<Draggable key="up" axis="y" onStart={this.recordPos} onDrop={this.topChange}
                                               style={{...styles.handle, ...styles.vHandle, ...styles.topHandle}}
                                               placeholderElement={<span/>} previewElement={upDownPreview}/>)
    if (handles.down) handleElms.push(<Draggable key="down" axis="y" onStart={this.recordPos} onDrop={this.bottomChange}
                                                 style={{...styles.handle, ...styles.vHandle, ...styles.bottomHandle}}
                                                 placeholderElement={<span/>} previewElement={upDownPreview}/>)
    if (handles.left) handleElms.push(<Draggable key="left" axis="x" onStart={this.recordPos} onDrop={this.leftChange}
                                                 style={{...styles.handle, ...styles.hHandle, ...styles.leftHandle}}
                                                 placeholderElement={<span/>} previewElement={leftRightPreview}/>)
    if (handles.right) handleElms.push(<Draggable key="right" axis="x" onStart={this.recordPos}
                                                  onDrop={this.rightChange}
                                                  style={{...styles.handle, ...styles.hHandle, ...styles.rightHandle}}
                                                  placeholderElement={<span/>} previewElement={leftRightPreview}/>)

    return (
        <div ref={this.containerRef} style={styles.container}>
          {this.props.children}
          {handleElms}
        </div>
    )
  }
}

Resizable.propTypes = {
  children: propTypes.any,
  handles: propTypes.shape({
    up: propTypes.bool,
    down: propTypes.bool,
    left: propTypes.bool,
    right: propTypes.bool,
  }).isRequired,
  height: propTypes.number.isRequired,
  onSize: propTypes.func.isRequired,
  leftRightPreview: propTypes.element,
  upDownPreview: propTypes.element,
  handleSize: propTypes.number,
}

Resizable.defaultProps = {
  handleSize: 10,
}

Resizable.contextTypes = {
  muiTheme: propTypes.object.isRequired,
  dragLayer: propTypes.object.isRequired,
}

export default Resizable
